var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiEmojiNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4118_273459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 56.25C23.0381 56.25 16.3613 53.4844 11.4384 48.5616C6.51562 43.6387 3.75 36.9619 3.75 30C3.75 23.0381 6.51562 16.3613 11.4384 11.4384C16.3613 6.51562 23.0381 3.75 30 3.75C36.9619 3.75 43.6387 6.51562 48.5616 11.4384C53.4844 16.3613 56.25 23.0381 56.25 30C56.25 36.9619 53.4844 43.6387 48.5616 48.5616C43.6387 53.4844 36.9619 56.25 30 56.25ZM30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 22.0435 56.8393 14.4129 51.2132 8.7868C45.5871 3.16071 37.9565 0 30 0C22.0435 0 14.4129 3.16071 8.7868 8.7868C3.16071 14.4129 0 22.0435 0 30C0 37.9565 3.16071 45.5871 8.7868 51.2132C14.4129 56.8393 22.0435 60 30 60Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 39.375C15 39.8723 15.1975 40.3492 15.5492 40.7008C15.9008 41.0525 16.3777 41.25 16.875 41.25H43.125C43.6223 41.25 44.0992 41.0525 44.4508 40.7008C44.8025 40.3492 45 39.8723 45 39.375C45 38.8777 44.8025 38.4008 44.4508 38.0492C44.0992 37.6975 43.6223 37.5 43.125 37.5H16.875C16.3777 37.5 15.9008 37.6975 15.5492 38.0492C15.1975 38.4008 15 38.8777 15 39.375ZM26.25 24.375C26.25 21.27 24.57 18.75 22.5 18.75C20.43 18.75 18.75 21.27 18.75 24.375C18.75 27.48 20.43 30 22.5 30C24.57 30 26.25 27.48 26.25 24.375ZM41.25 24.375C41.25 21.27 39.57 18.75 37.5 18.75C35.43 18.75 33.75 21.27 33.75 24.375C33.75 27.48 35.43 30 37.5 30C39.57 30 41.25 27.48 41.25 24.375Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4118_273459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiEmojiNeutral);
export default __webpack_public_path__ + "static/media/bi_emoji-neutral.08b6d701a319debcc898b7d936fad0f0.svg";
export { ForwardRef as ReactComponent };